import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ArrowLongSVG } from '@common_components/svg/arrowLong.svg';

const ArrowLongIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <ArrowLongSVG/>
    </div>
  );
};

export { ArrowLongIcon };
